import React, { useState } from 'react';
import { useStoreState } from 'easy-peasy';
import { useTheme } from '@mui/material/styles';
import { Stack, Box, Button, Popover, Paper, Backdrop } from '@mui/material';
import FilterBarSearch from './FilterBarSearch';
import SelectType from './SelectType';
import SelectDepots from './SelectDepots';
import utils from 'components/utils';

const FilterBar = props => {
	const theme = useTheme();
	const translate = utils.useI18N();

	return (
		<Stack direction="row" justifyContent="flex-start" alignItems="center" spacing={1} variant="wrapperColor">
			<FilterBarSearch />
			<SelectType />
			<SelectDepots />
		</Stack>
	);
};

export default FilterBar;
